// extracted by mini-css-extract-plugin
export default {"circleComp":"styles_circleComp__I4z3j","cardText":"styles_cardText__6mvfe","ratingArea":"styles_ratingArea__drgoj","ratings":"styles_ratings__Hcg3u"};